var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h2',{staticStyle:{"margin":"0","color":"#333","font-weight":"400"}},[_vm._v("我要上传")]),_c('div',{staticClass:"text"},[_vm._v(" 请将您的资料发到邮箱"+_vm._s(_vm.email)+"，或者加"+_vm._s(_vm.qq)+" 在线传输给我们，谢谢！ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }